// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__NE0eA","row":"Node_row__3d4gV","label":"Node_label__2Rjev","footer":"Node_footer__N8eoC"};